/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Patient_Calm_Flamingo_SplashInputs */

const fr_patient_calm_flamingo_splash = /** @type {(inputs: Patient_Calm_Flamingo_SplashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création d'un role`)
};

/**

* @param {Patient_Calm_Flamingo_SplashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const patient_calm_flamingo_splash = /** @type {((inputs?: Patient_Calm_Flamingo_SplashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Patient_Calm_Flamingo_SplashInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_patient_calm_flamingo_splash(inputs)
});